import styled, { css } from 'styled-components';

import { scale190, spaceXL, spaceL } from '@xing-com/tokens';

// *** Base ***
const baseGrid = css`
  margin: ${scale190} auto ${spaceXL};
  max-width: 560px;
  padding: ${spaceL};
`;

// *** Components ***
const Grid = styled.div`
  ${baseGrid}
`;

export const Styled = {
  Grid,
};
